"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgPlay = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M18 16.832v14.336L29.15 24 18 16.832zm-.46-2.673l14 9a1 1 0 010 1.682l-14 9A1 1 0 0116 33V15a1 1 0 011.54-.841z",
    id: "play_svg__a"
  }));
};

var _default = SvgPlay;
exports.default = _default;